import { useState } from 'react';
import axios from 'axios';

const API_V2 = process.env.REACT_APP_BACKEND_URL + '/api/v2';

/* Admin: Rundmail an alle User im CarmaCircle-Stil */

export const AdminBroadcast = ({ userCount }) => {
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [testEmail, setTestEmail] = useState('');
  const [sending, setSending] = useState(null); // 'test' | 'all'
  const [result, setResult] = useState(null);
  const [confirming, setConfirming] = useState(false);

  const send = async (isTest) => {
    if (!subject.trim() || !body.trim() || sending) return;
    setSending(isTest ? 'test' : 'all');
    setResult(null);
    try {
      const res = await axios.post(`${API_V2}/admin/broadcast-email`, {
        subject: subject.trim(),
        body: body.trim(),
        testEmail: isTest ? testEmail.trim() : null,
      }, { withCredentials: true });
      setResult({
        type: 'success',
        message: isTest
          ? `Testmail gesendet an ${testEmail.trim()}.`
          : `Rundmail gesendet: ${res.data.sent} erfolgreich, ${res.data.failed} fehlgeschlagen (von ${res.data.total}).`,
      });
      setConfirming(false);
    } catch (err) {
      setResult({ type: 'error', message: err.response?.data?.detail || 'Senden fehlgeschlagen.' });
    } finally {
      setSending(null);
    }
  };

  return (
    <div className="max-w-2xl" data-testid="admin-broadcast">
      <h2 className="mask-headline text-2xl mb-2">Rundmail an alle User</h2>
      <p className="text-sm text-[var(--muted)] mb-8">
        Wird im ruhigen CarmaCircle-Stil verschickt (Anrede mit Vornamen, Absender: beta@carmacircle.org).
        Absätze durch Leerzeile trennen.
      </p>

      <div className="space-y-6">
        <div>
          <label className="block text-xs uppercase tracking-[0.15em] text-[var(--muted)] mb-2">Betreff</label>
          <input
            type="text" value={subject} onChange={(e) => setSubject(e.target.value)}
            placeholder="z.B. CarmaCircle hat ein neues Zuhause bekommen"
            data-testid="broadcast-subject-input"
            className="w-full rounded-lg border px-4 py-3 focus:outline-none"
          />
        </div>
        <div>
          <label className="block text-xs uppercase tracking-[0.15em] text-[var(--muted)] mb-2">Text</label>
          <textarea
            value={body} onChange={(e) => setBody(e.target.value)} rows={10}
            placeholder={'wir haben CarmaCircle neu gestaltet …\n\nAußerdem gibt es jetzt MOMENTE …'}
            data-testid="broadcast-body-input"
            className="w-full rounded-lg border px-4 py-3 focus:outline-none leading-relaxed"
          />
        </div>

        <div className="pt-2 border-t border-gray-700">
          <label className="block text-xs uppercase tracking-[0.15em] text-[var(--muted)] mb-2 mt-4">Erst testen (empfohlen)</label>
          <div className="flex gap-3">
            <input
              type="email" value={testEmail} onChange={(e) => setTestEmail(e.target.value)}
              placeholder="deine@mail.de" data-testid="broadcast-test-email"
              className="flex-1 rounded-lg border px-4 py-2.5 focus:outline-none"
            />
            <button
              type="button" onClick={() => send(true)}
              disabled={!subject.trim() || !body.trim() || !testEmail.includes('@') || !!sending}
              data-testid="broadcast-test-btn"
              className="rounded-lg bg-blue-600 px-5 py-2.5 text-sm disabled:opacity-40"
            >
              {sending === 'test' ? 'Sendet …' : 'Testmail senden'}
            </button>
          </div>
        </div>

        <div className="pt-4">
          {!confirming ? (
            <button
              type="button" onClick={() => setConfirming(true)}
              disabled={!subject.trim() || !body.trim() || !!sending}
              data-testid="broadcast-send-all-btn"
              className="rounded-lg bg-blue-600 px-6 py-3 text-sm disabled:opacity-40"
            >
              An alle User senden{userCount ? ` (${userCount})` : ''}
            </button>
          ) : (
            <div className="flex items-center gap-4">
              <span className="text-sm text-[var(--muted)]">Wirklich an alle User senden?</span>
              <button type="button" onClick={() => send(false)} disabled={!!sending} data-testid="broadcast-confirm-btn"
                className="rounded-lg bg-blue-600 px-5 py-2.5 text-sm disabled:opacity-40">
                {sending === 'all' ? 'Sendet …' : 'Ja, jetzt senden'}
              </button>
              <button type="button" onClick={() => setConfirming(false)} data-testid="broadcast-cancel-btn"
                className="text-sm text-[var(--muted)] hover:text-white py-2">
                Abbrechen
              </button>
            </div>
          )}
        </div>

        {result && (
          <p className={`text-sm ${result.type === 'success' ? 'text-green-400' : 'text-red-400'}`} data-testid="broadcast-result">
            {result.message}
          </p>
        )}
      </div>
    </div>
  );
};
